"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditUserDetailsForm = void 0;
var react_1 = __importStar(require("react"));
var il_box_common_1 = require("../il-box/il-box.common");
var il_form_label_common_1 = require("../il-form-label/il-form-label.common");
var il_textfield_common_1 = require("../il-textfield/il-textfield.common");
var formik_1 = require("formik");
var edit_user_details_form_validation_1 = require("./edit-user-details-form.validation");
var il_action_dialog_1 = require("../il-action-dialog/il-action-dialog");
var enums_1 = require("../../shared/enums");
function EditUserDetailsForm(_a) {
    var open = _a.open, onClose = _a.onClose, user = _a.user, showEmailField = _a.showEmailField, onSubmit = _a.onSubmit;
    var undefinedIfEmpty = function (value) { return (value === '' ? undefined : value); };
    var formik = (0, formik_1.useFormik)({
        initialValues: {
            email: '',
            username: '',
            firstName: '',
            lastName: '',
        },
        validationSchema: edit_user_details_form_validation_1.EditUserDetailsValidation,
        onSubmit: function (values) {
            var onlyNonEmptyValues = {
                email: undefinedIfEmpty(values.email),
                username: undefinedIfEmpty(values.username),
                firstName: undefinedIfEmpty(values.firstName),
                lastName: undefinedIfEmpty(values.lastName),
            };
            submitUserDetailsForm(onlyNonEmptyValues);
        },
    });
    var _b = react_1.default.useState(enums_1.ActionDialogState.CONFIRM), dialogState = _b[0], setDialogState = _b[1];
    var _c = react_1.default.useState('The user could not be updated'), errorMessage = _c[0], setErrorMessage = _c[1];
    (0, react_1.useEffect)(function () {
        if (open === true) {
            setDialogState(enums_1.ActionDialogState.CONFIRM);
        }
    }, [open]);
    function submitUserDetailsForm(values) {
        return __awaiter(this, void 0, void 0, function () {
            var rejectReason_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setDialogState(enums_1.ActionDialogState.LOADING);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, onSubmit(values)];
                    case 2:
                        _a.sent();
                        setDialogState(enums_1.ActionDialogState.SUCCESS);
                        return [3 /*break*/, 4];
                    case 3:
                        rejectReason_1 = _a.sent();
                        setDialogState(enums_1.ActionDialogState.FAILURE);
                        if (rejectReason_1 instanceof Error) {
                            setErrorMessage(rejectReason_1.message);
                        }
                        else if (typeof rejectReason_1 === 'string') {
                            setErrorMessage(rejectReason_1);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function closeDialog() {
        onClose();
    }
    return (react_1.default.createElement(il_action_dialog_1.IlActionDialog, { onAction: formik.handleSubmit, onClose: closeDialog, open: open, dialogState: dialogState, title: 'Edit User Details', actionButtonLabel: 'Save', actionButtonDisabled: !formik.isValid, successText: "User details were updated successfully", failureText: errorMessage },
        react_1.default.createElement("form", { onSubmit: formik.handleSubmit },
            react_1.default.createElement(il_box_common_1.ILFormItemBox, null,
                react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "First Name"),
                react_1.default.createElement(il_textfield_common_1.LoginTextField, { id: 'firstName', value: formik.values.firstName, placeholder: user.firstName, onChange: formik.handleChange, error: Boolean(formik.errors.firstName), helperText: formik.errors.firstName })),
            react_1.default.createElement(il_box_common_1.ILFormItemBox, null,
                react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "Last Name"),
                react_1.default.createElement(il_textfield_common_1.LoginTextField, { id: 'lastName', value: formik.values.lastName, placeholder: user.lastName, onChange: formik.handleChange, error: Boolean(formik.errors.lastName), helperText: formik.errors.lastName })),
            react_1.default.createElement(il_box_common_1.ILFormItemBox, null,
                react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "Username"),
                react_1.default.createElement(il_textfield_common_1.LoginTextField, { id: 'username', value: formik.values.username, placeholder: user.username, onChange: formik.handleChange, error: Boolean(formik.errors.username), helperText: formik.errors.username })),
            showEmailField && (react_1.default.createElement(il_box_common_1.ILFormItemBox, null,
                react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "Email"),
                react_1.default.createElement(il_textfield_common_1.LoginTextField, { id: 'email', value: formik.values.email, placeholder: user.email, onChange: formik.handleChange, error: Boolean(formik.errors.email), helperText: formik.errors.email }))))));
}
exports.EditUserDetailsForm = EditUserDetailsForm;
